export const authority = "http://api.dnzapi.com";
// export const apiHostName = 'https://localhost:44347';
export const apiHostName = 'https://autorobodnz-001-site5.mtempurl.com';


export const host = 'http://localhost:3008'


